import React from "react";

import { connect } from "react-redux";
import { Redirect, Route, RouteProps } from "react-router";
import { createStructuredSelector } from "reselect";
import { selectIsAuthenticated } from "../../App/module/selectors";

export interface IPrivateRouteProps extends RouteProps {
  redirectPath: string;
}

const ProtectedRoute: React.FC<IPrivateRouteProps> = (
  props: IPrivateRouteProps
): JSX.Element => {
  const { component, redirectPath } = props;
  const tokenSession = sessionStorage.getItem("token");
  return tokenSession &&
    tokenSession !== null &&
    tokenSession &&
    tokenSession !== "" ? (
    <Route {...props} component={component} render={undefined} />
  ) : (
    <Redirect to={{ pathname: redirectPath }} />
  );
};

const mapStateToProps: any = () =>
  createStructuredSelector({
    isAuth: selectIsAuthenticated,
  });

const mapDispatchToProps: any = {};

const withConnect: any = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(ProtectedRoute);
